import React from "react";

function Myaccount() {
  return <div>My Account</div>;
}

export default Myaccount;
